<app-navbar></app-navbar>

<div class="row">
    <div class="col-10 offset-1 mt-5">
        <div class="card">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>